/* Theo yêu cầu anh Hoá — WEB-20260911-suzitee-pdp-desktop-pawfect
   Desktop-only (>=1024px) helper for the PDP gallery:
   - wraps the vertical thumbnail column so chevron buttons can be overlaid
   - adds up/down chevrons that scroll the column by exactly one thumbnail
   - keeps the column height equal to the main image height
   Does nothing below 1024px. No theme JS is modified or re-bound. */
(function () {
  var MQ = '(min-width: 1024px)';
  function init() {
    /* SZ-MOBILE-GUARD — Theo yêu cầu anh Hoá — WEB-20260911-suzitee-mobile-hscroll:
       never restructure the gallery DOM below 1024px (the .sz-thumbwrap wrapper broke the
       theme's direct-child selectors on mobile and let the thumbnail row overflow the page). */
    if (!window.matchMedia(MQ).matches) return;
    var wrapEl = document.querySelector('.gallery-thumbnails--left');
    if (!wrapEl) return;
    var nav = wrapEl.querySelector('.product_gallery_nav');
    var gallery = wrapEl.querySelector('.product_gallery');
    if (!nav || !gallery) return;
    if (nav.parentElement && nav.parentElement.classList.contains('sz-thumbwrap')) return;

    var holder = document.createElement('div');
    holder.className = 'sz-thumbwrap';
    nav.parentNode.insertBefore(holder, nav);
    holder.appendChild(nav);

    var up = document.createElement('button');
    up.type = 'button';
    up.className = 'sz-thumb-btn sz-thumb-btn--up';
    up.setAttribute('aria-label', 'Previous thumbnails');
    var down = up.cloneNode(false);
    down.className = 'sz-thumb-btn sz-thumb-btn--down';
    down.setAttribute('aria-label', 'More thumbnails');
    holder.appendChild(up);
    holder.appendChild(down);

    function step() {
      var cell = nav.querySelector('.gallery-cell');
      return cell ? cell.getBoundingClientRect().height + 12 : 120;
    }
    function scrollBy(dir) {
      var top = nav.scrollTop + dir * step();
      if (nav.scrollTo) nav.scrollTo({ top: top, behavior: 'smooth' });
      else nav.scrollTop = top;
    }
    up.addEventListener('click', function (e) { e.preventDefault(); scrollBy(-1); });
    down.addEventListener('click', function (e) { e.preventDefault(); scrollBy(1); });

    function sync() {
      if (!window.matchMedia(MQ).matches) { holder.classList.remove('is-ready'); return; }
      holder.classList.add('is-ready');
      var overflow = nav.scrollHeight - nav.clientHeight > 4;
      holder.classList.toggle('has-overflow', overflow);
      up.style.display = overflow && nav.scrollTop > 4 ? '' : 'none';
      down.style.display = overflow && nav.scrollTop < nav.scrollHeight - nav.clientHeight - 4 ? '' : 'none';
    }
    nav.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
    setTimeout(sync, 800);
    setTimeout(sync, 2500);
    if (window.ResizeObserver) { try { new ResizeObserver(sync).observe(gallery); } catch (e) {} }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', init);
})();

/* ===== Round 3 — Theo yêu cầu anh Hoá — WEB-20260911-suzitee-pdp-desktop-pawfect r3
   1) measures the sticky header and exposes --sz-sticky-top for the sticky gallery column
   2) flags .gallery-wrap with .sz-preview-active while a Customily live preview is showing,
      so the CSS can hide the original gallery image behind it (Customily files untouched).
   Desktop only; no theme/app JS is modified or re-bound. */
(function () {
  var MQ3 = '(min-width: 1024px)';

  function stickyTop() {
    if (!window.matchMedia(MQ3).matches) return;
    var h = 0;
    var els = document.querySelectorAll('.main-nav__wrapper, header .header-section, .header__wrapper');
    for (var i = 0; i < els.length; i++) {
      var s = getComputedStyle(els[i]);
      if (s.position !== 'fixed' && s.position !== 'sticky') continue;
      var b = els[i].getBoundingClientRect();
      if (b.top <= 2 && b.height > h && b.height < 220) h = b.height;
    }
    if (!h) h = 88;
    document.documentElement.style.setProperty('--sz-sticky-top', Math.round(h + 16) + 'px');
  }

  function previewFlag() {
    var wrap = document.querySelector('.gallery-wrap');
    if (!wrap) return;
    var cc = wrap.querySelector('.cl-canvas-container') || document.querySelector('.cl-canvas-container');
    var active = false;
    if (cc) {
      var inner = cc.querySelector('.canvas-container') || cc;
      var box = inner.getBoundingClientRect();
      active = !inner.classList.contains('op-zero') &&
               !cc.classList.contains('op-zero') &&
               box.width > 40 && box.height > 40 &&
               getComputedStyle(inner).display !== 'none' &&
               parseFloat(getComputedStyle(inner).opacity || '1') > 0.05;
      if (active && cc.parentElement !== wrap && !wrap.contains(cc)) active = false;
    }
    var next = !!active && window.matchMedia(MQ3).matches;
    if (wrap.classList.contains('sz-preview-active') !== next) wrap.classList.toggle('sz-preview-active', next);
  }

  /* r10 (Theo yêu cầu anh Hoá — WEB-20260911-suzitee-pdp-desktop r10):
     single-image products keep an empty 80px thumb gutter because the theme still renders the
     vertical nav. Count the real gallery cells and flag the wrap so CSS can collapse the column. */
  function singleImage() {
    var wrap = document.querySelector('.gallery-wrap');
    if (!wrap) return;
    if (!window.matchMedia(MQ3).matches) { if (wrap.classList.contains('sz-single-image')) wrap.classList.remove('sz-single-image'); return; }
    var main = wrap.querySelectorAll('.product_gallery .gallery-cell').length;
    var nav = wrap.querySelectorAll('.product_gallery_nav .gallery-cell').length;
    if (!main) main = wrap.querySelectorAll('.product_gallery img').length;
    var single = main === 1 && nav <= 1;
    if (wrap.classList.contains('sz-single-image') !== single) wrap.classList.toggle('sz-single-image', single);
  }

  function boot() {
    if (!window.matchMedia(MQ3).matches) return;
    stickyTop();
    previewFlag();
    singleImage();
    window.addEventListener('scroll', stickyTop, { passive: true });
    window.addEventListener('resize', function () { stickyTop(); previewFlag(); singleImage(); });
    if (window.MutationObserver) {
      try {
        new MutationObserver(function () { try { previewFlag(); singleImage(); } catch (error) { console.warn("SZ desktop update", error); } })
          .observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style'] });
      } catch (e) {}
    }
    setTimeout(function () { stickyTop(); previewFlag(); singleImage(); }, 1200);
    setTimeout(function () { stickyTop(); previewFlag(); singleImage(); }, 4000);
  }
  function safeBoot() { try { boot(); } catch (error) { console.warn('SZ desktop boot', error); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', safeBoot);
  else safeBoot();
})();
